import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import RouteImagePreloader from './components/RouteImagePreloader';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AuthCallbackPage from './pages/AuthCallbackPage';
import Panel from './pages/Panel';
import MentalHealthAssessmentPage from './pages/MentalHealthAssessmentPage';
import MentalHealthQuestionnairePage from './pages/MentalHealthQuestionnairePage';
import DassPage, { AudioProvider } from './pages/DassPage';
import DassAssessmentPage from './pages/DassAssessmentPage';
import StarOfWellbeingCompletion from './pages/StarOfWellbeingCompletion';
import './styles/main.scss';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <RouteImagePreloader />
          <Routes>
            <Route path="/" element={
              <ProtectedRoute requireAuth={false}>
                <LoginPage />
              </ProtectedRoute>
            } />
            <Route path="/login" element={
              <ProtectedRoute requireAuth={false}>
                <LoginPage />
              </ProtectedRoute>
            } />
            <Route path="/register" element={
              <ProtectedRoute requireAuth={false}>
                <RegisterPage />
              </ProtectedRoute>
            } />
            <Route path="/auth/callback" element={
              <ProtectedRoute requireAuth={false}>
                <AuthCallbackPage />
              </ProtectedRoute>
            } />
            <Route path="/mentalhealth" element={
              <ProtectedRoute requireAuth={false}>
                <AudioProvider>
                  <MentalHealthAssessmentPage />
                </AudioProvider>
              </ProtectedRoute>
            } />
            <Route path="/mentalhealth/questionnaire" element={
              <ProtectedRoute requireAuth={false}>
                <AudioProvider>
                  <MentalHealthQuestionnairePage />
                </AudioProvider>
              </ProtectedRoute>
            } />
            <Route path="/star-of-well-being" element={
              <ProtectedRoute requireAuth={false}>
                <AudioProvider>
                  <DassPage />
                </AudioProvider>
              </ProtectedRoute>
            } />
            <Route path="/star-of-well-being/assessment" element={
              <ProtectedRoute requireAuth={false}>
                <AudioProvider>
                  <DassAssessmentPage />
                </AudioProvider>
              </ProtectedRoute>
            } />
            <Route path="/star-of-well-being/assessment/completion" element={
              <ProtectedRoute requireAuth={false}>
                <AudioProvider>
                  <StarOfWellbeingCompletion />
                </AudioProvider>
              </ProtectedRoute>
            } />
            <Route path="/panel/*" element={
              <ProtectedRoute requireAuth={true}>
                <Panel />
              </ProtectedRoute>
            } />
          </Routes>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

